module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/arrow-prev-65d21c32da398ebfc7da91dc2604993e.svg&quot;;"